<template>
    <WidgetModal v-if="widgetModalState.opened && widgetModalState.token" />
</template>

<script setup lang="ts">
import WidgetModal from '@/components/molecules/WidgetModal.vue'
import useWidgetModal from '@/composables/widget/useWidgetModal'

const { widgetModalState } = useWidgetModal()
</script>
